module.exports = __webpack_public_path__ + "img/github-dark.ef7a02b6.png";